import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// old way render

// ReactDOM.render(
//     <App />,
//   document.getElementById('root')
// );

// fix error in rendering
var root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
